<template>
    <div v-if="hiddenPanelIds.length" class="mp-dock-hidden-slot q-pa-xs">
        <QBtn flat dense size="sm" icon="mdi-dock-window" label="Panels">
            <QMenu>
                <QList dense>
                    <QItem
                        v-for="pid in hiddenPanelIds"
                        :key="pid"
                        clickable
                        v-close-popup
                        @click="$emit('show', pid)"
                    >
                        <QItemSection avatar v-if="panelMeta(pid)?.icon">
                            <QIcon :name="panelMeta(pid).icon" />
                        </QItemSection>
                        <QItemSection>
                            {{ panelMeta(pid)?.title || pid }}
                        </QItemSection>
                    </QItem>
                </QList>
            </QMenu>
        </QBtn>
    </div>
</template>

<script>
import { QBtn, QIcon, QItem, QItemSection, QList, QMenu } from 'quasar';

export default {
    name: 'DockHiddenPanelsMenu',
    components: { QBtn, QIcon, QItem, QItemSection, QList, QMenu },

    props: {
        hiddenPanelIds: { type: Array, default: () => [] },
        getPanelMeta: { type: Function, default: () => () => ({}) },
    },

    emits: ['show'],

    methods: {
        panelMeta(id) {
            return this.getPanelMeta(id) || {};
        },
    },
};
</script>
